import { Options } from "ky";
import { fetcher } from "../fetcher";
import { getXsrfToken } from "../common";

export async function send(options?: Options): Promise<void> {
  await fetcher.extend({
    headers: {
      'X-XSRF-TOKEN': getXsrfToken(),
    },
  }).post('magazine/', { ...options, hooks: undefined }).json();
}
